import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-[520px] md:min-h-[600px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Flat%20lay%20of%20diverse%20fashion%20products%20including%20sneakers%20hoodies%20watches%20and%20bags%20arranged%20on%20dark%20wooden%20surface%20with%20warm%20golden%20side%20lighting%20editorial%20photography%20high%20contrast%20soft%20shadows%20no%20text%20no%20brands&width=1600&height=900&seq=hero-main-001&orientation=landscape"
          alt="Fashion products"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 via-foreground-950/60 to-foreground-950/40" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 py-16 md:py-20">
        <div className="max-w-3xl">
          <span className="inline-block text-xs md:text-sm font-medium tracking-[0.15em] uppercase text-primary-300 mb-4">
            {t('hero.eyebrow')}
          </span>
          <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-background-50 leading-tight mb-6">
            {t('hero.h1')}
          </h1>
          <p className="text-base md:text-lg text-background-200/90 leading-relaxed mb-8 max-w-xl">
            {t('hero.description')}
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              {t('hero.ctaPrimary')}
            </a>
            <a
              href="#categories"
              className="inline-flex items-center justify-center px-6 py-3 border border-background-300/60 text-background-50 font-medium rounded-md hover:bg-background-50/10 transition-colors whitespace-nowrap"
            >
              {t('hero.ctaSecondary')}
            </a>
          </div>
          <p className="mt-6 text-xs md:text-sm text-background-300/80 tracking-wide">
            {t('hero.trustLine')}
          </p>
        </div>
      </div>
    </section>
  );
}